export class Rect {
  static EMPTY = new Rect(0, 0, -1, -1);
  static IMPOSSIBLE = new Rect(NaN, NaN, 0, 0);
  static fromRectLike({
    x,
    y,
    width,
    height,
  }: {
    x: number;
    y: number;
    width: number;
    height: number;
  }) {
    return new Rect(x, y, width, height);
  }
  left: number;
  top: number;
  width: number;
  height: number;
  constructor(left: number, top: number, width: number, height: number) {
    this.left = left;
    this.top = top;
    this.width = width;
    this.height = height;
  }
  get right(): number {
    return this.left + this.width;
  }
  get bottom(): number {
    return this.top + this.height;
  }
}
